/* __next_internal_client_entry_do_not_use__ SearchDropdown auto */ import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import React, { useMemo, useState } from "react";
import DropdownList from "../DropdownList";
import { Input } from "../index";
/**
 * @trackcomponent
 */ export var SearchDropdown = function(_param) {
    var className = _param.className, style = _param.style, options = _param.options, autoselect = _param.autoselect, value = _param.value, _param_autoComplete = _param.autoComplete, autoComplete = _param_autoComplete === void 0 ? "off" : _param_autoComplete, name = _param.name, placeholder = _param.placeholder, label = _param.label, error = _param.error, disabled = _param.disabled, ariaLabel = _param["aria-label"], dataTestId = _param["data-test-id"], onChange = _param.onChange, onSelect = _param.onSelect, onBlur = _param.onBlur, ref = _param.ref, props = _object_without_properties(_param, [
        "className",
        "style",
        "options",
        "autoselect",
        "value",
        "autoComplete",
        "name",
        "placeholder",
        "label",
        "error",
        "disabled",
        "aria-label",
        "data-test-id",
        "onChange",
        "onSelect",
        "onBlur",
        "ref"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var search = value === null || value === void 0 ? void 0 : value.toLowerCase();
    var alternativeOptions = useMemo(function() {
        var _props_alternativeOptions;
        return (_props_alternativeOptions = props.alternativeOptions) === null || _props_alternativeOptions === void 0 ? void 0 : _props_alternativeOptions.map(function(option) {
            return option.toLowerCase();
        });
    }, [
        props.alternativeOptions
    ]);
    var filteredOptions = options.filter(function(option) {
        return !search || option.label.toLowerCase().indexOf(search) !== -1;
    });
    var searchInAlternativeOptions = isNotUndefined(search) && isNotUndefined(alternativeOptions) && alternativeOptions.includes(search);
    var handleInputOnChange = function(event) {
        onChange(event);
        // convert to lower case so matching against alternative options is case insensitive
        var search = event.target.value.toLowerCase();
        if (alternativeOptions === undefined || !alternativeOptions.includes(search)) {
            handleDropdownOpen();
        }
    };
    var handleSelectDropDown = function(optionValue) {
        var option = filteredOptions.find(function(option) {
            return option.value === optionValue;
        });
        onSelect(option);
        setIsOpen(false);
    };
    var handleDropdownOpen = function() {
        return setIsOpen(true);
    };
    var handleDropdownClose = function() {
        setIsOpen(false);
        if (autoselect && search && filteredOptions[0] && !searchInAlternativeOptions) {
            onSelect(filteredOptions[0]);
        }
    };
    var handleBlur = function() {
        handleDropdownClose();
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    };
    return /*#__PURE__*/ _jsx(DropdownList, {
        className: className,
        style: style,
        options: filteredOptions,
        open: isOpen,
        onOpen: handleDropdownOpen,
        onClose: handleDropdownClose,
        getLabel: function(option) {
            return option.label;
        },
        getValue: function(option) {
            return option.value;
        },
        onSelect: handleSelectDropDown,
        children: /*#__PURE__*/ _jsx(Input, {
            "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : name,
            disabled: disabled,
            label: label,
            error: error,
            name: name,
            value: value,
            placeholder: placeholder,
            onChange: handleInputOnChange,
            autoComplete: autoComplete,
            onBlur: handleBlur,
            onFocus: handleDropdownOpen,
            style: {
                width: "100%"
            },
            "aria-label": ariaLabel,
            ref: ref
        })
    });
};
